(() => {
  const initialized = window.__monarAnimatedDetails || new WeakSet();
  window.__monarAnimatedDetails = initialized;

  const setup = (details) => {
    if (initialized.has(details)) return;
    const summary = details.querySelector(':scope > summary');
    const content = summary?.nextElementSibling;
    if (!summary || !content) return;
    initialized.add(details);

    let animation;
    const finish = (open) => {
      animation = null;
      details.open = open;
      details.classList.remove('is-animating');
      details.style.removeProperty('height');
      details.style.removeProperty('overflow');
    };

    summary.addEventListener('click', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      event.preventDefault();
      if (animation) animation.cancel();

      const opening = !details.open;
      const startHeight = `${details.offsetHeight}px`;
      if (opening) details.open = true;
      const endHeight = `${opening ? summary.offsetHeight + content.offsetHeight : summary.offsetHeight}px`;

      details.classList.add('is-animating');
      details.style.overflow = 'hidden';
      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: opening ? 340 : 280, easing: 'cubic-bezier(.22,.61,.36,1)' }
      );
      content.animate(
        opening
          ? [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'translateY(0)' }]
          : [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(-4px)' }],
        { duration: opening ? 300 : 200, easing: 'ease', fill: 'both' }
      );
      animation.onfinish = () => finish(opening);
      animation.oncancel = () => finish(details.open);
    });
  };

  const initialize = (root = document) => root.querySelectorAll('[data-animated-details]').forEach(setup);
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
